export default "__VITE_ASSET__DcQmofzQ__"